<app-top-bar-widget class="sticky top-0 z-2" />

<router-outlet />
